import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/Header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../assets/img/logo1.png";
import { removeVietnameseTones } from "../../assets/removeVietKey";

// 1. IMPORT FIREBASE
import { db } from "../../assets/firebase/firebaseconfig"; // Đảm bảo đường dẫn này đúng tới file config firebase của bạn
import { ref, onValue, get } from "firebase/database";

const Header = ({ setHeaderHeight, currentUserd, onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const headerRef = useRef(null);
  const searchRef = useRef(null);

  const [isScrolled, setIsScrolled] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  // State lưu trữ dữ liệu thô từ Firebase
  const [allData, setAllData] = useState([]);

  // 2. LẤY DỮ LIỆU TỪ FIREBASE (ADMIN INPUT)
  useEffect(() => {
    const productsRef = ref(db, "products");
    const projectsRef = ref(db, "projects");

    // Lắng nghe sản phẩm
    const unsubProducts = onValue(productsRef, (snapshot) => {
      const data = snapshot.val();
      const productsList = data
        ? Object.keys(data).map((key) => ({
            id: key,
            ...data[key],
            type: "products",
          }))
        : [];

      // Lắng nghe dự án ngay sau đó để gộp lại
      onValue(projectsRef, (snapshotProj) => {
        const dataProj = snapshotProj.val();
        const projectsList = dataProj
          ? Object.keys(dataProj).map((key) => ({
              id: key,
              ...dataProj[key],
              type: "projects",
            }))
          : [];

        setAllData([...productsList, ...projectsList]);
      });
    });

    return () => unsubProducts(); // Dọn dẹp listener khi unmount
  }, []);

  // 3. LOGIC TÌM KIẾM TRÊN DỮ LIỆU FIREBASE
  useEffect(() => {
    if (searchTerm.trim().length > 0) {
      const searchNormalized = removeVietnameseTones(searchTerm.toLowerCase());

      const filtered = allData.filter((item) => {
        const nameToSearch = removeVietnameseTones(
          (item.name || item.title || "").toLowerCase()
        );
        return nameToSearch.includes(searchNormalized);
      });

      setSearchResults(filtered.slice(0, 10));
      setShowDropdown(true);
    } else {
      setSearchResults([]);
      setShowDropdown(false);
    }
  }, [searchTerm, allData]);

  // 4. HIỆU ỨNG CUỘN & ĐO CHIỀU CAO
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);

    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
      const observer = new ResizeObserver(() =>
        setHeaderHeight(headerRef.current.offsetHeight)
      );
      observer.observe(headerRef.current);
      return () => {
        window.removeEventListener("scroll", handleScroll);
        observer.disconnect();
      };
    }
  }, [setHeaderHeight]);

  // Đóng bảng khi chuyển trang
  useEffect(() => {
    setSearchTerm("");
    setShowDropdown(false);
    setIsMenuOpen(false);
  }, [location]);

  // Click ra ngoài để đóng bảng tìm kiếm
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Nếu click thực sự NẰM NGOÀI vùng searchRef thì mới đóng
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    // Dùng mousedown để nó chạy cùng lúc với cái e.preventDefault ở thẻ Link
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    if (window.confirm("Bạn muốn đăng xuất?")) {
      localStorage.removeItem("user");
      onLogout();
      navigate("/");
    }
  };

  const menuItems = [
    { name: "Trang chủ", path: "/" },
    { name: "Sản phẩm", path: "/san-pham" },
    { name: "Dự án", path: "/du-an" },
    { name: "Tin tức", path: "/tin-tuc" },
    { name: "Liên hệ", path: "/lien-he" },
  ];

  return (
    <header
      ref={headerRef}
      className={`header ${isScrolled ? "scrolled" : ""}`}
    >
      <div className="top-bar">
        <div className="container top-bar-content">
          <div className="top-bar-left">Chào mừng tới Habako M&E!</div>
          <div className="top-bar-right">
            {currentUserd ? (
              <div className="user-info">
                <span>
                  Xin chào, <strong>{currentUserd.username}</strong>
                </span>
                <img
                  src={
                    currentUserd.avatar ||
                    `https://ui-avatars.com/api/?name=${currentUserd.username}`
                  }
                  alt="Avatar"
                  className="user-avatar"
                />
                <span className="auth-divider">|</span>
                <button onClick={handleLogout} className="logout-btn">
                  Đăng xuất
                </button>
              </div>
            ) : (
              <div className="auth-links">
                <Link to="/dang-nhap">Đăng nhập</Link>
                <span className="auth-divider">|</span>
                <Link to="/dang-ky">Đăng ký</Link>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="header-main">
        <div className="header__logo">
          <Link to="/" className="logo__content">
            <img src={Logo} className="img__logo" alt="logo" />
            <div className="logo__text">
              <span className="logo__text--top">HABAKO</span>
              <br />
              <span className="logo__text--bottom">M&E</span>
            </div>
          </Link>
        </div>

        <button
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? "✕" : "☰"}
        </button>

        <div className={`header__actions ${isMenuOpen ? "open" : ""}`}>
          <nav className="header__nav">
            <ul className="nav__list">
              {menuItems.map((item, index) => (
                <li key={index} className="nav__item">
                  <Link
                    to={item.path}
                    className={`nav__link ${
                      location.pathname.startsWith(item.path) &&
                      (item.path !== "/" || location.pathname === "/")
                        ? "active"
                        : ""
                    }`}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="header__action__right">
            <form
              className="search-form"
              ref={searchRef}
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="input-group-wrapper">
                <input
                  type="text"
                  placeholder="Tìm sản phẩm, dự án..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setShowDropdown(true);
                  }}
                  onFocus={() => setShowDropdown(true)}
                />

                {showDropdown && (
                  <div className="live-search-results">
                    {searchResults.length > 0 ? (
                      searchResults.map((item) => {
                        const isProd = item.type === "products";
                        const url = isProd
                          ? `/san-pham/${item.id}`
                          : `/du-an/${item.id}`;
                        return (
                          <Link
                            key={`${item.type}-${item.id}`}
                            to={
                              isProd
                                ? `/san-pham/${item.id}`
                                : `/du-an/${item.id}`
                            }
                            className="search-item"
                            onMouseDown={(e) => {
                              // NGĂN chặn việc mất focus của input và nổi bọt lên document
                              e.preventDefault();

                              navigate(
                                item.type === "products"
                                  ? `/san-pham/${item.id}`
                                  : `/du-an/${item.id}`
                              );
                              setTimeout(() => {
                                setShowDropdown(false);
                                setSearchTerm("");
                              }, 10);
                            }}
                          >
                            <img
                              src={item.mediaUrl || item.image || Logo}
                              alt=""
                            />
                            <div className="search-item-info">
                              <span className="search-name">
                                {item.name || item.title}
                              </span>
                              <span className={`search-type ${item.type}`}>
                                {isProd ? "Sản phẩm" : "Dự án"}
                              </span>
                            </div>
                          </Link>
                        );
                      })
                    ) : (
                      <div className="no-result">Không tìm thấy kết quả</div>
                    )}
                  </div>
                )}
              </div>
            </form>
            <div className="header__hotline">
              <span className="hotline__label">Hotline:</span>
              <Link href="tel:0866306661" className="hotline__number">
                0866306661
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
